import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { getPartner } from "@lib/linkUtils";
import { isBrowser } from "@lib/utils";
import { atom } from "nanostores";

const tracingUrls = [
  import.meta.env.PUBLIC_WEBAPP_GRAPHQL_URL,
  ...(isBrowser() ? [window.location.origin] : []),
];

datadogRum.init({
  applicationId: "41bf820d-f7f7-4b54-a575-761b1ec8f299",
  clientToken: "puba3792df089224cb166ac003070cedd83",
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: "datadoghq.com",
  service: "core-webapp",
  env: import.meta.env.PUBLIC_SST_STAGE,
  // Specify a version number to identify the deployed version of your application in Datadog
  version: "1.0.0",
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  allowedTracingUrls: [(url) => tracingUrls.includes(url)],
  proxy(options) {
    return (
      import.meta.env.PUBLIC_WEBAPP_GRAPHQL_URL +
      "/ddproxy" +
      options.path +
      "?" +
      options.parameters
    );
  },
  defaultPrivacyLevel: "mask-user-input",
});

datadogLogs.init({
  clientToken: "puba3792df089224cb166ac003070cedd83",
  site: "datadoghq.com",
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
  service: "starlight-webapp",
  env: import.meta.env.PUBLIC_SST_STAGE,
  // Specify a version number to identify the deployed version of your application in Datadog
  version: "1.0.0",
  forwardConsoleLogs: "all",
  storeContextsAcrossPages: true,
  proxy(options) {
    return (
      import.meta.env.PUBLIC_WEBAPP_GRAPHQL_URL +
      "/ddproxy" +
      options.path +
      "?" +
      options.parameters
    );
  },
});

if (isBrowser()) {
  datadogRum.setGlobalContextProperty(
    "partner",
    getPartner(new URL(import.meta.url)),
  );
  datadogLogs.setGlobalContextProperty(
    "partner",
    getPartner(new URL(import.meta.url)),
  );
}

export const $logger = atom(datadogLogs);

export const $datadog = atom(datadogRum);
